  (function () {
    function initLensScrollSection(root) {
    if (!root || root.dataset.sutyoLensReady === 'true') return;
    root.dataset.sutyoLensReady = 'true';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const heroImages = Array.from(root.querySelectorAll('[data-hero-image]'));
    const imageOverlay = root.querySelector('[data-image-overlay]');
    const visualFrame = root.querySelector('[data-visual-frame]');
    const heroCopy = root.querySelector('[data-hero-copy]');
    const controlPanel = root.querySelector('[data-control-panel]');
    const panelCopy = root.querySelector('[data-panel-copy]');
    const scrollSection = root.querySelector('.sutyo-lens__scroll');
    const pinStage = root.querySelector('.sutyo-lens__pin-stage');
    const slider = root.querySelector('[data-filter-slider]');
    const modeButtons = root.querySelectorAll('[data-mode-btn]');
    const stageNoise = root.querySelector('.sutyo-lens__noise');

    if (!heroImages.length || !imageOverlay || !visualFrame || !heroCopy || !controlPanel || !scrollSection || !pinStage || !slider || !modeButtons.length) {
      return;
    }

    let activeMode = root.dataset.initialMode || 'color';
    let resizeFrame = null;
    let resizeTimeout = null;
    let hasStartedAnimation = false;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const heroImagesByKey = heroImages.reduce((map, image) => {
      const key = image.dataset.imageKey;
      if (key) {
        map[key] = image;
      }
      return map;
    }, {});
    const initialStrength = clamp(Number.parseFloat(root.dataset.initialStrength || '0') || 0, 0, 100);
    const getDesktopPanelGap = () => {
      const gap = Number.parseFloat(window.getComputedStyle(root).getPropertyValue('--sutyo-lens-panel-gap-desktop'));
      return Number.isFinite(gap) ? gap : 30;
    };
    const getViewportHeight = () => window.innerHeight || document.documentElement.clientHeight || 0;
    const getViewportWidth = () => window.innerWidth || document.documentElement.clientWidth || 0;
    const getTargets = () => {
      const isCompact = window.matchMedia('(max-width: 900px)').matches;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const headerOffset = 0;
      const viewportHeight = getViewportHeight();
      const viewportWidth = getViewportWidth();
      const availableHeight = Math.max(viewportHeight - headerOffset, viewportHeight * 0.5);
      const panelHeight = controlPanel.offsetHeight || 0;
      const bottomSafeArea = isCompact ? 12 : 24;

      if (isMobile) {
        const panelGap = 18;
        const frameSize = Math.max(
          220,
          Math.min(
            viewportWidth - 40,
            availableHeight - panelHeight - panelGap - bottomSafeArea - 12
          )
        );
        const totalGroupHeight = frameSize + panelGap + panelHeight;
        const centeredGroupTop = (viewportHeight - totalGroupHeight) / 2;
        const minGroupTop = headerOffset + 12;
        const groupTop = Math.max(centeredGroupTop, minGroupTop);

        return {
          headerOffset,
          scale: 1,
          frameOffsetY: groupTop,
          radius: 21,
          panelTop: groupTop + frameSize + panelGap,
          mobileFrameSize: frameSize,
        };
      }

      const frameScale = isCompact ? 0.68 : 0.6;
      const frameHeight = availableHeight * frameScale;
      const panelGap = isCompact ? 14 : getDesktopPanelGap();
      const defaultCenterY = headerOffset + (availableHeight / 2);
      const defaultFrameBottom = defaultCenterY + (frameHeight / 2);
      const spaceBelow = viewportHeight - defaultFrameBottom;
      const spaceNeeded = panelGap + panelHeight + bottomSafeArea;

      let frameOffsetY = 0;
      if (spaceBelow < spaceNeeded) {
        frameOffsetY = -(spaceNeeded - spaceBelow);
        const minOffset = -(defaultCenterY - (frameHeight / 2) - headerOffset);
        frameOffsetY = Math.max(frameOffsetY, minOffset);
      }

      const desktopFrameLift = Number.parseFloat(window.getComputedStyle(root).getPropertyValue('--sutyo-lens-frame-lift-desktop')) || 0;
      frameOffsetY += desktopFrameLift;

      const frameCenterY = defaultCenterY + frameOffsetY;
      const panelTop = frameCenterY + (frameHeight / 2) + panelGap;

      return {
        headerOffset,
        scale: frameScale,
        frameOffsetY,
        radius: isCompact ? 24 : 34,
        panelTop,
        mobileFrameSize: null,
      };
    };
    const syncLayoutVars = () => {
      const targets = getTargets();
      root.style.setProperty('--sutyo-lens-header-offset', `${targets.headerOffset}px`);
      root.style.setProperty('--sutyo-lens-panel-top', `${targets.panelTop}px`);
      if (targets.mobileFrameSize) {
        root.style.setProperty('--sutyo-lens-mobile-frame-size', `${targets.mobileFrameSize}px`);
      } else {
        root.style.removeProperty('--sutyo-lens-mobile-frame-size');
      }
      return targets;
    };
    const getScrollDistance = () => {
      const scrollLength = Number(root.dataset.scrollLength || 250);
      return (getViewportHeight() * scrollLength) / 100;
    };
    const syncScrollHeight = () => {
      scrollSection.style.height = `${getViewportHeight() + getScrollDistance()}px`;
    };
    const getSliderPercent = () => clamp(Number.parseFloat(slider.value) || 0, 0, 100);
    const getSliderStep = () => {
      const progress = getSliderPercent();
      if (progress <= 0) return 0;
      if (progress >= 67) return 3;
      if (progress >= 34) return 2;
      return 1;
    };
    const updateSliderUI = () => {
      const progress = `${getSliderPercent()}%`;
      root.style.setProperty('--sutyo-lens-slider-progress', progress);
    };

    const getActiveImageKey = () => {
      const stepValue = getSliderStep();
      if (stepValue <= 0) return 'default';
      return `${activeMode}-${stepValue}`;
    };

    const applyFilter = () => {
      const nextKey = getActiveImageKey();
      const activeImage = heroImagesByKey[nextKey] || heroImagesByKey.default || heroImages[0];

      heroImages.forEach((image) => {
        const isActive = image === activeImage;
        image.classList.toggle('is-active', isActive);
        image.style.filter = 'none';
      });

      imageOverlay.style.background = 'transparent';
      imageOverlay.style.mixBlendMode = 'normal';
      imageOverlay.style.opacity = '0';
    };

    const updatePanelCopy = () => {
      if (!panelCopy) return;

      const nextCopy =
        activeMode === 'light'
          ? panelCopy.dataset.lightCopy || panelCopy.dataset.colorCopy || ''
          : panelCopy.dataset.colorCopy || panelCopy.dataset.lightCopy || '';

      panelCopy.innerHTML = nextCopy.replace(/\n/g, '<br>');
    };

    const setMode = (nextMode) => {
      activeMode = nextMode;
      root.style.setProperty(
        '--sutyo-lens-slider-gradient',
        nextMode === 'light'
          ? `linear-gradient(90deg, ${root.dataset.lightSliderStart || '#FFFFFF'} 0%, ${root.dataset.lightSliderEnd || '#808080'} 100%)`
          : `linear-gradient(90deg, rgba(255, 255, 255, 0.22) 0%, #ff0000 33.333%, #d000ff 66.666%, #002fff 100%)`
      );

      modeButtons.forEach((button) => {
        const isActive = button.dataset.mode === nextMode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      updatePanelCopy();
      applyFilter();
    };

    const buildScrollAnimation = () => {
      syncLayoutVars();
      syncScrollHeight();

      if (!window.gsap || !window.ScrollTrigger || prefersReducedMotion) {
        const targets = syncLayoutVars();
        root.style.setProperty('--sutyo-lens-header-offset', `${targets.headerOffset}px`);
        controlPanel.style.opacity = '1';
        controlPanel.style.visibility = 'visible';
        controlPanel.style.transform = 'translateX(-50%)';
        root._sutyoLensCleanup = () => {
          delete root.dataset.sutyoLensReady;
        };
        return;
      }

      if (root._sutyoLensCleanup) {
        root._sutyoLensCleanup();
      }

      hasStartedAnimation = true;
      window.gsap.registerPlugin(window.ScrollTrigger);


        /* 默认居中 */

        /* 下方空间不够时，将图片整体上移 */
          /* 确保图片顶部不超过 header 区域 */
      const ctx = window.gsap.context(() => {
        syncScrollHeight();
        syncLayoutVars();
        window.gsap.set(visualFrame, {
          x: 0,
          y: 0,
          scale: 1,
          width: '',
          height: '',
          borderRadius: 0,
          boxShadow: 'none',
        });
        window.gsap.set(controlPanel, { y: 46, autoAlpha: 0 });

        window.ScrollTrigger.create({
          trigger: root,
          start: 'top bottom',
          end: 'bottom top',
          onEnter: () => {
            controlPanel.style.visibility = 'visible';
          },
          onEnterBack: () => {
            controlPanel.style.visibility = 'visible';
          },
          onLeave: () => {
            controlPanel.style.visibility = 'hidden';
          },
          onLeaveBack: () => {
            controlPanel.style.visibility = 'hidden';
          },
        });

          window.gsap.timeline({
            scrollTrigger: {
              trigger: scrollSection,
              start: 'top top',
              end: () => `+=${getScrollDistance()}`,
              scrub: 1,
              invalidateOnRefresh: true,
              onRefreshInit: () => {
                syncScrollHeight();
                syncLayoutVars();
              },
            },
          })
          .to(heroCopy, { autoAlpha: 0, duration: 0.22, ease: 'none' }, 0.232)
          .to(stageNoise, { opacity: 1, duration: 0.52, ease: 'none' }, 0.1)
          .to(
            visualFrame,
            {
              scale: () => getTargets().scale,
              y: () => getTargets().frameOffsetY,
              width: () => (window.matchMedia('(max-width: 749px)').matches ? `${getTargets().mobileFrameSize}px` : `${window.innerWidth}px`),
              height: () => (
                window.matchMedia('(max-width: 749px)').matches
                  ? `${getTargets().mobileFrameSize}px`
                  : `${Math.max(getViewportHeight() - getTargets().headerOffset, getViewportHeight() * 0.5)}px`
              ),
              borderRadius: () => getTargets().radius,
              boxShadow: '0 28px 90px rgba(0, 0, 0, 0.42)',
              duration: 0.72,
              ease: 'none',
            },
            0.16
          )
          .to(
            controlPanel,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.28,
              ease: 'none',
            },
            0.72
          );
      }, root);

      const handleResize = () => {
        if (resizeFrame) {
          window.cancelAnimationFrame(resizeFrame);
        }
        if (resizeTimeout) {
          window.clearTimeout(resizeTimeout);
        }

        resizeFrame = window.requestAnimationFrame(() => {
          syncScrollHeight();
          syncLayoutVars();
          if (window.ScrollTrigger) {
            window.ScrollTrigger.refresh();
          }
        });

        resizeTimeout = window.setTimeout(() => {
          syncScrollHeight();
          syncLayoutVars();
          if (window.ScrollTrigger) {
            window.ScrollTrigger.refresh();
          }
        }, 180);
      };

      window.addEventListener('resize', handleResize, { passive: true });
      window.addEventListener('orientationchange', handleResize);

      root._sutyoLensCleanup = () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);

        if (resizeFrame) {
          window.cancelAnimationFrame(resizeFrame);
          resizeFrame = null;
        }

        if (resizeTimeout) {
          window.clearTimeout(resizeTimeout);
          resizeTimeout = null;
        }

        ctx.revert();
        delete root.dataset.sutyoLensReady;
      };
    };

    slider.addEventListener('input', () => {
      updateSliderUI();
      applyFilter();
    });

    modeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setMode(button.dataset.mode);
      });
    });

    slider.value = String(initialStrength);
    updateSliderUI();
    setMode(activeMode);

    const startLensScroll = () => {
      if (hasStartedAnimation) return;
      buildScrollAnimation();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startLensScroll, { once: true });
    } else {
      startLensScroll();
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== root && !event.target.contains(root)) return;
      if (root._sutyoLensCleanup) {
        root._sutyoLensCleanup();
      }
    });
    }

    function initAllLensScrollSections() {
      document.querySelectorAll('.sutyo-lens[data-section-id]').forEach(initLensScrollSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllLensScrollSections, { once: true });
    } else {
      initAllLensScrollSections();
    }

    document.addEventListener('shopify:section:load', initAllLensScrollSections);
  })();
